import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AppSmallWindowPane from "../../../../../AppComponents/AppSmallWindowPane";
import {
  AppForm,
  AppFormSelectField,
  AppFormSwitchField,
  AppFormTextArea,
  AppSubmitButton,
} from "../../../../../AppComponents/Forms";
import { useNotification } from "../../../../../Hooks/useNotification/useNotification";
import { EnabledDevicesSchema } from "../../../../../Models/ValidationSchema";
import { ChatbotConsoleService } from "../../../../../Services/Apis/ChatbotConsoleService";
import { ChangeSelectedBot, useCurrentBot } from "../../../../../Store/Slices/DashboardSlices";
import { ChatbotConfiguration } from "../../../../../Models/ChatbotConfiguration";
import { AxiosResponse } from "axios";
import { LoaderComponentProps, withLoader } from "../../../../../AppComponents/Loader";
import AppFormSliderField from "../../../../../AppComponents/Forms/AppFormSliderField";
import { Slider } from "@mui/material";
import AppFormCountSliderField from "../../../../../AppComponents/Forms/AppFormSilder";
import { useAppDispatch } from "../../../../../Store";
import { AIServiceSettingsActions } from "../../../../../Store/Slices/Settings/AIServiceSettings/aiServiceSettings.actions";
import {
  Box,
  Typography,
  Switch,
  Paper,
  Chip,
} from "@mui/material";
import MotionPhotosAutoIcon from '@mui/icons-material/MotionPhotosAuto';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { log } from "node:console";
interface Props extends LoaderComponentProps { }
const EnabledDevices = (props: Props) => {
  const { showAlert } = useNotification();
  const [autoRouter, setAutoRouter] = useState(false);
  const [initialAutoRouter, setInitialAutoRouter] = useState(false);
  const dispatch = useAppDispatch()
  const currentBot: any = useSelector(useCurrentBot);
  const [modelNametype, setModelName] = useState<string>("");
  const [userInput, setUserInput] = useState<any>({
    prompt: "",
    temperature: 0
  });
  const [openRouterModels, setOpenRouterModels] = useState<any[]>([]);
  const [openAiModels, setOpenAiModels] = useState<any[]>([]);
  const [aiConfigModel, setAiConfigModel] = useState<any>({});
  const [modelsLoaded, setModelsLoaded] = useState(false);

  const getData = () => {
    if (!currentBot?.chatbot_configuration) return;

  };

   useEffect(() => {  
      getData();
    }, []);
  
  console.log("currentBot", currentBot);

  const handleSubmitBtn = (values: any, SubmitProps: any) => {    
    const modelName = autoRouter ? modelNametype : values.modelName;
    
    // Get openRouterKey and normalKey by matching name in openRouterModels array
    const modelsList = aiConfigModel.service_type === "openrouter" ? openRouterModels : openAiModels;
    const matchedModel = modelsList.find((model: any) => 
      model.normalKey === modelName || model.name === modelName
    );
    
    const openRouterKey = matchedModel?.openRouterKey || modelName;
    const normalKey = matchedModel?.normalKey || modelName;

    
    setUserInput(values);
    const ai_configuration = {
      auto_router: autoRouter,
      model: normalKey,
      openRouterKey: openRouterKey,
      normalKey: normalKey,
      temperature: values.temperature,
      enabled: autoRouter,
      use_global_settings: true,   // or true, depending on your UI
      is_global: autoRouter,             // since this is per-bot config
      key_type: botConfigData,
      ai_key_type: botConfigData,
      prompt: values.prompt
    };

    console.log(values, "valuesvaluesvaluesvalues");
    console.log("Matched Model:", matchedModel);
    console.log("OpenRouter Key:", openRouterKey, "Normal Key:", normalKey);

    ChatbotConsoleService.createUpdateBotConfiguration(
      currentBot.id as string,
      {
        chatbot: {...currentBot,prompt: values.prompt },
        chatbot_configuration: {prompt: values.prompt, modelName: modelName, temperature: values.temperature, ai_configuration: ai_configuration },
      }
    )
      .then((response) => {
        dispatch(ChangeSelectedBot(response?.data?.chatbot));
        SubmitProps.setSubmitting(false);
        showAlert("Configuration updated successfully", "success");
            ChatbotConsoleService.getBotConfiguration(
          currentBot.chatbot_configuration as string
      ).then((res: AxiosResponse<ChatbotConfiguration>) => {
                  if (res?.data?.ai_configuration?.auto_router) {
              setAutoRouter(res.data.ai_configuration.auto_router);
              setInitialAutoRouter(res.data.ai_configuration.auto_router);
            }
            setModelName(res.data.ai_configuration.model);
            const modelsList = aiConfigModel.service_type === "openrouter" ? openRouterModels : openAiModels;
        
        const matchedModel = modelsList.find((model: any) => 
          model.normalKey == res.data.ai_configuration.model
        );
            setUserInput((prevState: any) => ({
              ...prevState,
              modelName: matchedModel ? matchedModel.name : "",
              temperature : res.data.ai_configuration.temperature,
              prompt : res.data.ai_configuration.prompt,
            })  
            );
          });
      })
      .catch((error) => {
        SubmitProps.setSubmitting(false);
        showAlert(error?.response?.statusText || 'Something went wrong', "error");
      });
  };
  const [modelOptions, setModelOptions] = useState<{ label: string; value: string }[]>([]);
  // Ensure setBotConfigData is defined and not duplicated
  const [botConfigData, setBotConfigData] = useState<ChatbotConfiguration>();
  const [autorouterenable, setAutorouterenable] = useState<boolean>(false);
  //  useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const res: any = await dispatch(AIServiceSettingsActions.getApiKey({}));
  //       setAutorouterenable(res?.payload?.data?.has_client_key);
  //       const botRes: AxiosResponse<ChatbotConfiguration> =
  //         await ChatbotConsoleService.getBotConfiguration(
  //           currentBot.chatbot_configuration as string
  //         );

  //       if (botRes?.data?.show_suggestion) {
  //         setBotConfigData(botRes?.data?.ai_configuration?.key_type);
  //       }
  //     } catch (err) {
  //       console.error("Error in saveApiKey/getBotConfiguration:", err);
  //     }
  //   };

  //   if (currentBot?.chatbot_configuration) {
  //     fetchData();
  //   }
  // }, [currentBot, dispatch]);
  useEffect(() => {
    dispatch(AIServiceSettingsActions.getOpenRouterSettings({}))
      .then((res: any) => {
        let response = res?.payload?.data
        console.log("OpenRouter Settings Response:", response?.available_models_for_open_ai?.models,response?.available_models?.models);
        setOpenRouterModels(response?.available_models?.models || []);
        setOpenAiModels(response?.available_models_for_open_ai?.models || []);
        setAiConfigModel(response?.current_config?.config_value);
        setModelsLoaded(true);
        if(response?.current_config?.config_value?.service_type ==="openrouter"){
          setAutorouterenable(true)
        }
        
        // log("OpenRouter Settings Response:", response?.data?.available_models_for_open_ai?.models,response?.data?.available_models?.models);
        // if (res?.payload?.data?.auto_router_enabled !== undefined) {
        //   setAutoRouter(res.payload.data.auto_router_enabled);
        // }
      })
      .catch((error) => {
        console.error("Failed to get OpenRouter settings:", error);
        setModelsLoaded(true);
      });

    props.setLoading(false)

  }, [dispatch]);

  // Load bot configuration after models are loaded
  useEffect(() => {
    if (!modelsLoaded || !currentBot?.chatbot_configuration) return;

    ChatbotConsoleService.getBotConfiguration(
      currentBot.chatbot_configuration as string
    )
      .then((res: AxiosResponse<any>) => {
        const modelsList = aiConfigModel.service_type === "openrouter" ? openRouterModels : openAiModels;
        console.log("modelsList",modelsList,res);
        
        const matchedModel = modelsList.find((model: any) => 
          model.normalKey === res.data.ai_configuration?.model ||  model.name == res.data.ai_configuration?.model
        );
        console.log("matchedModel",matchedModel,aiConfigModel);
        
          setUserInput((prevState: any) => ({
              modelName: matchedModel ? matchedModel.name : "",
              temperature : res.data.ai_configuration?.temperature || 0,
              prompt : res.data.ai_configuration?.prompt || "",
          }));
          
          if (res?.data?.ai_configuration?.auto_router) {
            setAutoRouter(res.data.ai_configuration.auto_router);
            setInitialAutoRouter(res.data.ai_configuration.auto_router);
          }
      })
      .catch((error: any) => {
        console.error("Failed to load bot configuration:", error);
      });
  }, [modelsLoaded, currentBot?.chatbot_configuration]);

  // useEffect(() => {
  //   dispatch(
  //     AIServiceSettingsActions.getAIServiceSettings({
  //       search: "",
  //       provider: "",
  //     })
  //   ).then((res: any) => {
  //     if (res?.payload.data?.data?.models?.length) {
  //       const mappedModels = res.payload.data.data.models.map((model: any) => ({
  //         label: model.name,
  //         value: model.name,
  //       }));

  //       setModelOptions(mappedModels);
  //     }
  //   });
  // }, [dispatch]);
  return (
    <AppSmallWindowPane>
      {/* AI Service Configuration Status */}
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          mb: 2,
          bgcolor: 'info.50',
          borderColor: 'info.200',
          borderLeft: '4px solid',
          borderLeftColor: 'info.main',
        }}
      >
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          You are using{' '}
          <Typography component="span" variant="body2" fontWeight={700} sx={{ color: 'info.main' }}>
            {aiConfigModel?.service_type === "openrouter" ? "Smart AI LLM" : aiConfigModel?.service_type === "client" ? "Own API Key" : "Default Configuration"}
          </Typography>
          {' '}from AI Services Configuration.{' '}
          <Typography
            component="span"
            variant="body2"
            fontWeight={700}
            sx={{
              color: 'primary.main',
              cursor: 'pointer',
              textDecoration: 'underline',
              '&:hover': {
                opacity: 0.8,
              },
            }}
            onClick={() => window.open('/settings/ai_service_settings', '_blank')}
          >
            Click here
          </Typography>
          {' '}to change settings.
        </Typography>
      </Paper>

      {autorouterenable && (
        <Paper
          variant="outlined"
          sx={{
            p: 2.5,
            mb: 2,
            bgcolor: 'linear-gradient(135deg, rgba(103, 58, 183, 0.05) 0%, rgba(103, 58, 183, 0.02) 100%)',
            borderColor: 'secondary.200',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: 2,
            borderLeft: '4px solid',
            borderLeftColor: 'secondary.main',
            transition: 'all 0.3s ease',
            '&:hover': {
              boxShadow: '0 4px 12px rgba(103, 58, 183, 0.1)',
            }
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: 'secondary.100',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(103, 58, 183, 0.15)',
            }}>
              <MotionPhotosAutoIcon sx={{ color: 'black', fontSize: 22 }} />
            </Box>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'text.primary', fontSize: '0.95rem' }}>
                  Auto Router Configuration
                </Typography>
                {autoRouter && (
                  <Chip
                    icon={<AutoAwesomeIcon sx={{ fontSize: 14 }} />}
                    label="Active"
                    size="small"
                    color="secondary"
                    sx={{
                      height: 20,
                      fontSize: '0.7rem',
                      fontWeight: 600,
                      '& .MuiChip-icon': {
                        marginLeft: '4px',
                      }
                    }}
                  />
                )}
              </Box>
              <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.4, display: 'block' }}>
                Automatically select the optimal model for each request
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Typography 
              variant="caption" 
              fontWeight={600}
              sx={{ 
                color: autoRouter ? 'success.main' : 'text.secondary',
                transition: 'color 0.3s ease',
                textTransform: 'uppercase',
                fontSize: '0.7rem',
                letterSpacing: 0.5,
              }}
            >
              {autoRouter ? 'ON' : 'OFF'}
            </Typography>
            <Switch
              checked={autoRouter}
              onChange={async (e) => {
                const newValue = e.target.checked;
                setAutoRouter(newValue);
                // try {
                //   await dispatch(AIServiceSettingsActions.saveOpenRouterSettings({
                //     auto_router: newValue
                //   })).then((res => {
                //     setModelName(res.payload.data.model_saved);
                //   }));
                // } catch (error) {
                //   console.error("Failed to save OpenRouter settings:", error);
                //   setAutoRouter(!newValue); // Revert on error
                // }
              }}
              sx={{
                '& .MuiSwitch-switchBase': {
                  color: '#bdbdbd',
                  '&.Mui-checked': {
                    color: '#4caf50',
                    '& + .MuiSwitch-track': {
                      bgcolor: '#4caf50',
                      opacity: 0.5,
                    },
                  },
                },
                '& .MuiSwitch-track': {
                  bgcolor: '#bdbdbd',
                  opacity: 0.38,
                },
                '& .MuiSwitch-thumb': {
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                },
              }}
            />
          </Box>
        </Paper>
      )}
      <AppForm
        enableReinitialize={true}
        initialValues={userInput}
        onSubmit={(values: any, submitProps: any) => {
          handleSubmitBtn(values, submitProps);
        }}
        // validationSchema={EnabledDevicesSchema}
      >
        {({ dirty, values }) => {
          // Check if form is dirty OR auto router changed
          const hasChanges = dirty || (autoRouter !== initialAutoRouter);
          
          return (
            <>
              {/* Show Model dropdown only if Auto Router is NOT enabled */}
              {!autoRouter && (
                <AppFormSelectField
                  label="Model"
                  Options={aiConfigModel.service_type === "openrouter" ? openRouterModels : openAiModels}
                  name="modelName"
                  tooltip="Select an AI model to use for generating responses."
                  divStyle={{ maxWidth: "100%" }}
                />)}
              <AppFormTextArea style={{ maxHeight: "90px", minHeight: "335px" }} label="Enter Prompt" name={"prompt"} />
              <AppFormCountSliderField label="Temperature" name="temperature" />

              <AppSubmitButton
                variant="cta"
                style={{ width: "100%", margin: "0.5rem 0" }}
                title={"Save Changes"}
                disabled={!hasChanges}
              />
            </>
          );
        }}
      </AppForm>
    </AppSmallWindowPane>
  );
};

export default withLoader(EnabledDevices);
